export default __webpack_public_path__ + "media/images/features/ja/map_line_3-2f5157f368c998fea9e0f0382e6366c7.png";